/**
 * Préparation d'un logo pour l'impression.
 *
 * pdfmake ne restitue pas la transparence comme un navigateur : le logo de la
 * fédération contient de grandes lettres BLANCHES sur fond transparent,
 * invisibles sur la feuille à l'écran mais rendues en gris pâle dans le PDF.
 * On aplatit donc l'image sur du blanc — la couleur de la feuille — et on la
 * réduit à une taille suffisante pour l'impression.
 */

export const LARGEUR_MAXIMALE = 800

export function aplatirSurBlanc (source, largeurMaximale) {
  return new Promise(function (resoudre) {
    if (!source) {
      resoudre(null)
      return
    }

    const image = new window.Image()

    image.onload = function () {
      try {
        const limite = largeurMaximale || LARGEUR_MAXIMALE
        const echelle = Math.min(1, limite / image.width)
        const canvas = document.createElement('canvas')
        canvas.width = Math.max(1, Math.round(image.width * echelle))
        canvas.height = Math.max(1, Math.round(image.height * echelle))

        const contexte = canvas.getContext('2d')
        contexte.fillStyle = '#ffffff'
        contexte.fillRect(0, 0, canvas.width, canvas.height)
        contexte.drawImage(image, 0, 0, canvas.width, canvas.height)

        resoudre(canvas.toDataURL('image/png'))
      } catch (erreur) {
        // Canvas indisponible ou image d'une autre origine : mieux vaut le logo
        // d'origine qu'aucun logo
        resoudre(source)
      }
    }

    image.onerror = function () { resoudre(source) }
    image.src = source
  })
}

export default {aplatirSurBlanc, LARGEUR_MAXIMALE}



// WEBPACK FOOTER //
// ./src/utils/facture/logo.js